export default "__VITE_ASSET__CUOIaB9y__"